export const Thirty = 'b';